function o(e, t, i) {
  try {
    var r = new XMLHttpRequest();
    r.open("GET", e + t, !0),
      (r.onload = function () {
        if (200 === r.status) {
          var e = JSON.parse(r.response);
          e.success === !0
            ? e.content && (i.innerHTML = e.content)
            : e.error && n && n.error("Vivino widget error: ", e.error);
        }
      }),
      r.setRequestHeader(
        "Content-Type",
        "application/x-www-form-urlencoded; charset=UTF-8"
      ),
      r.send();
  } catch (o) {
    console.log("Vivino widget error: Browser not supported", o);
  }
}
function a(e) {
  if (e.dataset.vivinoUserId != i) {
    var t = "?user_id=" + e.dataset.vivinoUserId;
    e.dataset.vivinoWidgetLayout &&
      (t += "&layout=" + e.dataset.vivinoWidgetLayout),
      e.dataset.vivinoWidgetIncludeReview &&
      (t += "&include_review=" + e.dataset.vivinoWidgetIncludeReview),
      o("https://www.vivino.com/external/widgets/user", t, e);
  } else console.error("Vivino widget error: Missing user id on", e);
}
function s(e) {
  if (e.dataset.vivinoVintageId != i) {
    var t = "?vintage_id=" + e.dataset.vivinoVintageId;
    e.dataset.vivinoWidgetLayout &&
      (t += "&layout=" + e.dataset.vivinoWidgetLayout),
      e.dataset.vivinoWidgetReadReviews &&
      (t += "&read_review=" + e.dataset.vivinoWidgetReadReviews),
      e.dataset.vivinoWidgetFeaturedDescription &&
      (t +=
        "&featured_review=" +
        e.dataset.vivinoWidgetFeaturedDescription),
      e.dataset.vivinoUserId &&
      (t += "&user_id=" + e.dataset.vivinoUserId),
      e.dataset.vivinoWidgetLanguage &&
      (t += "&language=" + e.dataset.vivinoWidgetLanguage),
      o("https://www.vivino.com/external/widgets/vintage", t, e);
  } else console.error("Vivino widget error: Missing wine id on", e);
}

$(document).ready(() => {
  const elements = $('.vivino-widget')
  if (elements.length > 0) {
    for (var r = elements.length - 1; r >= 0; r--) {
      var o = elements[r];
      if (o.dataset)
        switch (o.dataset.vivinoWidgetType) {
          case "user":
            a(o);
            break;
          case "wine":
            s(o);
        }
    }
  }
})